import React, { useEffect, useState } from 'react';
import { Outlet, useParams, useNavigate, useLocation } from 'react-router-dom';
import api from '../../api';
import { useAuth, findUserGuild } from '../../contexts/AuthContexte';
import { useAccess } from '../../contexts/AccessContext';
import { useLanguage } from '../../contexts/LanguageContext';
import AdminSidebar from '../layout/AdminSidebar';
import AdminDashboard from './AdminDashboard';
import './AccueilPage.css';

// Erreurs de /servers/:id qui signifient que le bot n'est pas (ou plus) sur le serveur
const isBotMissing = (error) => {
    const status = error.response?.status;
    const message = error.response?.data?.error || '';
    return [403, 404, 503].includes(status)
        || ['Bot Discord non connecté', 'Serveur non trouvé', 'bot non présent', "Le bot n'a pas accès"].some(m => message.includes(m));
};

/**
 * Espace administrateur d'un serveur : menu latéral + page courante
 * (le tableau de bord sur /server/:serverId, les sous-pages via <Outlet />).
 */
const AccueilPage = () => {
    const { serverId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useLanguage();
    const { token, user } = useAuth();
    const [server, setServer] = useState(null);
    const [loading, setLoading] = useState(true);

    const { can, loading: accessLoading } = useAccess();
    const hasAccess = can(serverId);

    // Nom et icône du serveur connus à la connexion (le bot complète si besoin)
    const guildFromJWT = findUserGuild(user, serverId);

    useEffect(() => {
        if (!token) {
            navigate('/');
            return;
        }
        if (accessLoading) return;
        // Aucun droit d'administration sur ce serveur : direction l'espace membre
        if (!hasAccess) {
            navigate(`/server/${serverId}/member`);
            return;
        }

        let cancelled = false;
        setLoading(true);
        api.get(`/servers/${serverId}`)
            .then(res => {
                if (cancelled) return;
                const apiServer = res.data.server || {};
                setServer({ ...apiServer, id: serverId, name: apiServer.name || guildFromJWT?.name, icon: guildFromJWT?.icon || apiServer.icon });
            })
            .catch(error => {
                if (cancelled) return;
                if (isBotMissing(error)) {
                    navigate(`/server/${serverId}/bot-not-present`);
                    return;
                }
                console.error('❌ Erreur récupération serveur :', error);
                setServer({ id: serverId, name: guildFromJWT?.name || serverId, icon: guildFromJWT?.icon });
            })
            .finally(() => { if (!cancelled) setLoading(false); });

        return () => { cancelled = true; };
        // guildFromJWT dérive de user : inutile de le suivre séparément
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serverId, token, user, navigate, accessLoading, hasAccess]);

    const isHomePage = location.pathname.replace(/\/$/, '') === `/server/${serverId}`;

    if (loading) {
        return (
            <main className="c2-page admin-loading">
                <div className="c2-spinner" />
                <p className="c2-muted">{t('common.loading')}</p>
            </main>
        );
    }

    return (
        <div className="c2-bg admin-shell">
            <AdminSidebar server={server} />
            <main className="admin-shell__content">
                {isHomePage ? <AdminDashboard server={server} /> : <Outlet />}
            </main>
        </div>
    );
};

export default AccueilPage;
